import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "../../../hooks/useTheme";
import { Badge } from "../../../components/Badge";
import { IListElement } from "../types";
import { Icon } from "../../../components/Icon";

export const ListElement: React.FC<IListElement> = ({
  iconType,
  text,
  ...rest
}) => {
  const { css } = useFela();
  const { colors, bp } = useTheme();

  return (
    <li
      className={css({
        marginTop: 25,
        display: "flex",
        alignItems: "center",
        [bp.FROM_DESKTOP]: {
          marginTop: 45,
        },
      })}
      {...rest}
    >
      <Badge
        size={40}
        customStyle={{
          backgroundColor: colors.WHITE,
          boxShadow: `4px 8px 8px 0 ${colors.CETACEAN_BLUE}`,
        }}
      >
        <Icon iconType={iconType} />
      </Badge>

      <p
        className={css({
          fontSize: 20,
          marginLeft: 20,
          letterSpacing: "0.75px",
          color: colors.DARK_GREY,
          [bp.FROM_DESKTOP]: {
            fontSize: 24,
          },
        })}
      >
        {text}
      </p>
    </li>
  );
};
